import { render } from "./Testimonials.vue?vue&type=template&id=f214baa4&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=f214baa4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f214baa4"]])

export default __exports__